import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState, useCallback } from 'react';
import { Button } from 'antd';
import {
  deleteFortnightlys,
  getAllYears,
} from '../../../../appRedux/actions/Fortnightly';
import { stringDate } from '../../../../util';
import { ListTable, ModalView, TableMenuOpt } from '../../../uiComponents';
import { FortnightlyWeeksModal } from '../FortnightlyWeeksModal';
import { useCustomModal } from '../../../../hooks/useCustomModal';

export const FortnightlyTable = () => {
  const dispatch = useDispatch();

  const {
    privileges: { fortnightly: privileges = [] },
  } = useSelector((state) => state.userAuth);

  const { fortnightlys } = useSelector((state) => state.fortnightlys);

  const { catalogId, setModal } = useCustomModal();

  const [modalTitle, setModalTitle] = useState(null);

  const onDelete = (id) => {
    dispatch(deleteFortnightlys(id));
  };

  const getModalData = useCallback(() => {
    if (!fortnightlys?.length || !catalogId) return null;
    const [found] = fortnightlys.filter((row) => row.id === catalogId);
    return found;
  }, [fortnightlys, catalogId]);

  useEffect(() => {
    const data = getModalData();
    setModalTitle(data?.fortnightly_year);
  }, [getModalData]);

  const columns = [
    {
      title: 'Año',
      sorter: true,
      dataIndex: 'fortnightly_year',
      key: 'fortnightly_year',
      render: (value, row) => (
        <Button
          type="link"
          htmlType="button"
          href="#/"
          onClick={() => setModal(row.fortnightly_id)}
        >
          {value}
        </Button>
      ),
    },
    {
      title: 'Semana de inicio',
      dataIndex: 'fortnightly_base_week_start_date',
      key: 'fortnightly_base_week_start_date',
      render: (date) => stringDate(date),
    },
    {
      title: 'Semanas',
      dataIndex: 'fortnightly_weeksCount',
      key: 'fortnightly_weeksCount',
    },
    {
      title: 'Opciones',
      key: 'id',
      render: (_, { fortnightly_id }) => (
        <TableMenuOpt
          id={fortnightly_id}
          hideEdit
          privileges={privileges}
          path="catorcenas"
          action={{
            onDelete: {
              action: onDelete,
              params: [fortnightly_id],
            },
          }}
        />
      ),
    },
  ];

  return (
    <>
      <ListTable
        columns={columns}
        getDataFunction={getAllYears}
        privileges={privileges}
      />

      <ModalView title={modalTitle}>
        <FortnightlyWeeksModal catalogId={catalogId} />
      </ModalView>
    </>
  );
};
